import React, { useCallback, useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Pivot, PivotItem } from '@fluentui/react';

export const AppAdPreviewControls = (props) => {
  const {
    onSurfaceChange,
    onPlacementFilterChange,
    showStart,
  } = props;

  const [surfaceChoice, setSurfaceChoice] = useState('Windows');

  const surfaceMap = useMemo(() => ({
    Windows: showStart ? ['Windows11StartLight', 'Windows11StartDark', 'Windows10StartLight', 'Windows10StartDark', 'WindowsProngLight', 'WindowsProngDark'] : ['Windows11ProngLight', 'WindowsProngDark'],
    Store: ['WindowsStoreSpotLight'],
  }), []);

  const placementFilterByPreviewControlState = useCallback((placement) => {
    const { type: previewTemplateType } = placement;
    const surfaceList = surfaceMap[surfaceChoice];

    return _.contains(surfaceList, previewTemplateType);
  }, [surfaceChoice, surfaceMap]);

  useEffect(() => {
    onPlacementFilterChange(placementFilterByPreviewControlState);
  }, [onPlacementFilterChange, placementFilterByPreviewControlState]);

  useEffect(() => {
    onSurfaceChange(surfaceChoice);
  }, [onSurfaceChange, surfaceChoice]);

  return (
    <div className="ad-preview-controls-container">
      <Pivot onLinkClick={item => setSurfaceChoice(item.props.itemKey)}>
        <PivotItem
          itemKey="Windows"
          headerText="Windows"
        />
        <PivotItem
          itemKey="Store"
          headerText="Microsoft Store"
        />
      </Pivot>
    </div>);
};

AppAdPreviewControls.propTypes = {
  onSurfaceChange: PropTypes.func.isRequired,
  onPlacementFilterChange: PropTypes.func.isRequired,
  showStart: PropTypes.bool.isRequired,
};
